import { gql } from '@apollo/client';
const UPDATE_TENANT_ELEMENT = gql `
  mutation UpdateTenantElement($elementId: ID!, $name: String!) {
    updateModelSpecificationTemplateElement(elementId: $elementId, name: $name) {
      modelSpecificationTemplateElement {
        id
        name
      }
    }
  }
`;
export default UPDATE_TENANT_ELEMENT;
